import { Edit03Icon } from '@langchain/untitled-ui-icons';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function AnnotationQueuesCrumb(props: Partial<BreadcrumbData>) {
  return (
    <Breadcrumb
      icon={props.condensed ? <Edit03Icon className="size-4" /> : undefined}
      name={props.condensed ? '' : 'Annotation Queues'}
      {...props}
    />
  );
}
